type SortDir = 'asc' | 'desc'
type SortType = 'number' | 'string'

type Options = {
  key?: string | null
  dir?: SortDir
}

export default ({ key = null, dir = 'asc' }: Options = {}) => ({
  sortKey: key,
  sortDir: dir as SortDir,
  sorted: false,
  initialRows: [] as HTMLTableRowElement[],

  init() {
    const tbody = (this as any).$root.querySelector('tbody') as HTMLTableSectionElement | null

    this.initialRows = tbody ? Array.from(tbody.querySelectorAll('tr')) : []
  },

  sort(trigger: HTMLElement) {
    const sortKey = trigger.dataset.sortKey

    if (!sortKey) return

    const type: SortType = trigger.dataset.sortType === 'string' ? 'string' : 'number'
    const dir: SortDir = this.sortKey === sortKey && this.sortDir === 'asc' ? 'desc' : 'asc'

    const tbody = (this as any).$root.querySelector('tbody') as HTMLTableSectionElement | null

    if (!tbody) return

    const rows = this.initialRows.length ? [...this.initialRows] : Array.from(tbody.querySelectorAll('tr'))

    rows.sort((a, b) => {
      const rawA = this._cellValue(a, sortKey)
      const rawB = this._cellValue(b, sortKey)

      if (type === 'number') {
        const numA = parseFloat(rawA)
        const numB = parseFloat(rawB)
        const valA = Number.isNaN(numA) ? -Infinity : numA
        const valB = Number.isNaN(numB) ? -Infinity : numB

        return dir === 'asc' ? valA - valB : valB - valA
      }

      return dir === 'asc' ? rawA.localeCompare(rawB) : rawB.localeCompare(rawA)
    })

    rows.forEach((row) => tbody.appendChild(row))

    this.sortKey = sortKey
    this.sortDir = dir
    this.sorted = !this._isInitialOrder(rows)
  },

  _cellValue(row: HTMLTableRowElement, sortKey: string) {
    const cell = row.querySelector<HTMLElement>(`[data-sort-key="${sortKey}"]`)

    return cell?.dataset.sortValue ?? cell?.textContent?.trim() ?? ''
  },

  _isInitialOrder(rows: HTMLTableRowElement[]) {
    return rows.length === this.initialRows.length && rows.every((row, index) => row === this.initialRows[index])
  },
})
